import imageOne from '@/assets/images/cities/vancouver1.jpg'
import imageTwo from '@/assets/images/cities/vancouver2.jpg'
import imageThree from '@/assets/images/cities/vancouver3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Vancouver',
  // writeup: '',
  writeup:
    'Unfortunately our Vancouver Location is currently unavailable. Sorry for the inconvenience.',

  website: 'MyVancouverNotaryPublic.com',
  url: 'https://www.myvancouvernotarypublic.com/',
  // notaries: [
  //   {
  //     name: '',
  //     open: false,
  //     phone: '',
  //     hours: {
  //       monday: '',
  //       tuesday: '',
  //       wednesday: '',
  //       thursday: '',
  //       friday: '',
  //       saturday: '',
  //       sunday: ''
  //     },
  //     address: '',
  //     notes: ''
  //   }
  // ]
  notaries: [
    // {
    //   name: '',
    //   open: true,
    //   phone: '(604) 343-1010',
    //   hours: {
    //     monday: '10:00AM to 5:00PM',
    //     tuesday: '10:00AM to 5:00PM',
    //     wednesday: '10:00AM to 5:00PM',
    //     thursday: '10:00AM to 5:00PM',
    //     friday: '10:00AM to 3:30PM',
    //     saturday: 'Closed',
    //     sunday: 'Closed'
    //   },
    //   address: '1111 Melville Street Location',
    //   notes: ''
    // },
    // {
    //   name: '',
    //   open: true,
    //   phone: '(604) 343-1010',
    //   hours: {
    //     monday: '8:30AM to 8:00PM',
    //     tuesday: '8:30AM to 8:00PM',
    //     wednesday: '8:30AM to 8:00PM',
    //     thursday: '8:30AM to 8:00PM',
    //     friday: '8:30AM to 8:00PM',
    //     saturday: '12:00PM to 4:00PM',
    //     sunday: 'Closed'
    //   },
    //   address: '1111 Alberni Street Location',
    //   notes: ''
    // },
    {
      name: '',
      open: true,
      phone: '(604) 343-1010',
      hours: {
        monday: '9:00AM to 5:00PM',
        tuesday: '9:00AM to 5:00PM',
        wednesday: '9:00AM to 5:00PM',
        thursday: '9:00AM to 5:00PM',
        friday: '9:00AM to 5:00PM',
        saturday: 'Closed',
        sunday: 'Closed'
      },
      address: 'W Georgia Street Location',
      notes: ''
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/britishColumbia/cities/vancouver.js